'use strict'

import escapeRegexString from './escape-regex-string'

export default function (pattern) {
    pattern = escapeRegexString(pattern.replace(/\*/g, '__WILDCARD__'))

    return new RegExp('^' + pattern.replace(/__WILDCARD__/g, '.+') + '$')
};
